import { ONE_YEAR_SECONDS } from '@moda/portal-stanchions';
import { useCallback, useEffect, useState } from 'react';
import { CONFIG } from '../config';
import { useAddressesQuery } from './useAddress';
import { useCookies } from './useCookies';
import { useUser } from './useUser';

export const useSmartyStreetsState = (zipCodeFromUser: string | undefined) => {
  const [loading, setLoading] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [abbreviation, setAbbreviation] = useState<string>();
  const [name, setName] = useState<string>();
  const { user } = useUser();
  const { addresses } = useAddressesQuery();
  const zipCodeFromUserAddresses = addresses && addresses[0]?.attributes.postalCode;

  const {
    cookies: { zipCode, stateAbbreviation, stateName },
    setCookie
  } = useCookies();

  const saveToCookies = useCallback(
    (zipCode: string, abbreviation: string, name: string) => {
      setCookie('zipCode', zipCode, ONE_YEAR_SECONDS);
      setCookie('stateAbbreviation', abbreviation, ONE_YEAR_SECONDS);
      setCookie('stateName', name, ONE_YEAR_SECONDS);
    },
    [setCookie]
  );

  const newLoggedInUser =
    user.isLoggedIn && zipCodeFromUserAddresses && !stateAbbreviation && !stateName && !zipCode;
  const returnedLoggedInUser =
    user.isLoggedIn &&
    stateAbbreviation !== '' &&
    stateName !== '' &&
    zipCodeFromUserAddresses !== undefined;

  useEffect(() => {
    if (
      returnedLoggedInUser &&
      zipCodeFromUserAddresses === zipCodeFromUser &&
      zipCodeFromUserAddresses === zipCode
    ) {
      setAbbreviation(stateAbbreviation);
      setName(stateName);
    } else if (
      (newLoggedInUser ||
        zipCodeFromUser !== zipCodeFromUserAddresses ||
        zipCodeFromUserAddresses !== zipCode) &&
      zipCodeFromUser !== undefined
    ) {
      setLoading(true);
      fetch(`${CONFIG.DISCOVERY_API_URL}/lookup?zipcode=${zipCodeFromUser}`, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrer: 'no-referrer',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.errors && data.errors[0]) {
            return data.errors[0].detail;
          }
          if (data[0].zipcodes) {
            user.isLoggedIn &&
              (newLoggedInUser || zipCodeFromUserAddresses !== zipCode) &&
              saveToCookies(
                zipCodeFromUserAddresses,
                data[0].zipcodes[0].state_abbreviation,
                data[0].zipcodes[0].state
              );
            setAbbreviation(data[0].zipcodes[0].state_abbreviation);
            setName(data[0].zipcodes[0].state);
          } else {
            setIsInvalid(true);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    newLoggedInUser,
    returnedLoggedInUser,
    setAbbreviation,
    stateAbbreviation,
    stateName,
    zipCode,
    zipCodeFromUser,
    zipCodeFromUserAddresses,
    saveToCookies,
    user.isLoggedIn
  ]);

  return { loading, isInvalid, abbreviation, name };
};
